import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Transactions from "./pages/Transactions";
import HtmlDisplay from "./pages/HtmlDisplay";
import AppSelector from "./pages/AppSelector";
import ProjectDetail from "./pages/ProjectDetail";
import Fibre from "./pages/fibre";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/app-selector" element={<AppSelector />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/html-display" element={<HtmlDisplay />} />
        <Route path="/projectdetail" element={<ProjectDetail />} />
        <Route path="/fibre" element={<Fibre />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
